<script lang="ts">
    import { onDestroy } from 'svelte'
    import ZinputExpander from './zinput-expander.svelte'
    import Zinput from '../zinput.svelte'
    import type { GridButton } from '../zgrid'

    export let query: string = ''
    export let label = ''
    export let disabled = false
    export let acts: GridButton[] = []
    export let showClear = true
    export let minLength = 3
    export let debounceMs = 700
    export let search: (query: string) => void = null

    let delay: ReturnType<typeof setTimeout> = null

    function triggerSearch(q: string) {
        if (delay) clearTimeout(delay)
        if (!q || q.length < minLength) {
            search?.('')
            return
        }
        delay = setTimeout(() => search?.(q), debounceMs)
    }

    $: triggerSearch(query)

    let open = false
    // o fechamento é adiado para o clique num resultado acontecer antes do blur fechar o painel. se o
    // campo recupera o foco nesse meio tempo (é o que o "x" de limpar faz), o fechamento é cancelado —
    // senão o painel sumiria logo depois, com o cursor de volta no campo
    let closeDelay: ReturnType<typeof setTimeout> = null

    function onFocus() {
        clearTimeout(closeDelay)
        open = true
    }
    function onBlur() {
        clearTimeout(closeDelay)
        closeDelay = setTimeout(() => {
            open = false
        }, 300)
    }

    onDestroy(() => clearTimeout(closeDelay))
</script>

<ZinputExpander customTrigger={true} {disabled} bind:open>
    <svelte:fragment slot="trigger">
        <!-- type=search + autocomplete=off: é um campo de busca, não um dado do usuário. sem isso o
             navegador olha o texto em volta (ex.: "Buscar por nome, telefone ou e-mail") e oferece
             autopreenchimento de endereço/e-mail por cima da lista de resultados. -->
        <Zinput type="search" autocomplete="off" bind:value={query} {label} {disabled} {acts} {showClear} on:focus={onFocus} on:blur={onBlur} on:clear />
    </svelte:fragment>
    <svelte:fragment slot="panel" let:close>
        <!-- query pode chegar nula de quem usa (bind com um campo que vem vazio do servidor), e o slot é
             montado antes de qualquer normalização — por isso o ?? aqui -->
        <slot {close} tooShort={(query ?? '').length < minLength} />
    </svelte:fragment>
</ZinputExpander>
